import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './layouts/dashboard/dashboard.component';
import { HomeComponent } from './home/home.component';
import { FormComponent } from './form/form.component';
import { ServicesComponent } from './services/services.component'; 
import { EntitiesComponent } from './entities/entities.component';
import { SectionsComponent } from './sections/sections.component';
import { ServciesLayoutComponent } from './layouts/servcies-layout/servcies-layout.component';
import { MyRequestsComponent } from './my-requests/my-requests.component';
import { InvestmentDashboardComponent } from './investement/investment-dashboard/investment-dashboard.component';
import { InvestmentProfileComponent } from './investement/investment-profile/investment-profile.component';
import { InvestementSignupComponent } from './investement/investement-signup/investement-signup.component';
import { InvestmentForgetPasswordComponent } from './investement/investment-forget-password/investment-forget-password.component';
import { ConsumerGuard } from 'src/security/consumer.guard';
import { CompanyInfoComponent } from './investement/company-info/company-info.component';
import { FilterRequestsComponent } from './Admin/filter-requests/filter-requests.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { ReciptComponent } from './Admin/recipt/recipt.component';
import { InvestmentUsersComponent } from './Admin/investment-users/investment-users.component';
import { CompaniesComponent } from './Admin/companies/companies.component';
import { InvestmentUserViewComponent } from './Admin/investment-user-view/investment-user-view.component';
import { ServiceOutputComponent } from './investement/service-output/service-output.component';
// import { AdminGuard } from 'src/security/admin.guard';
import { AuthGuard } from 'src/security/auth.guard';
import { TestComponent } from './test/test.component';
import { JamarekComponent } from './investement/jamarek/jamarek.component';
import { EdtiJamarekComponent } from './investement/edti-jamarek/edti-jamarek.component';
import { JamarekTransferQuantityComponent } from './investement/jamarek-transfer-quantity/jamarek-transfer-quantity.component';
import { EditJamarekTransferQuantityComponent } from './investement/edit-jamarek-transfer-quantity/edit-jamarek-transfer-quantity.component';
import { AdminGuard } from 'src/security/admin.guard';
import { ExemptionsComponent } from './Admin/exemptions/exemptions.component';
import { FinanceGuard } from 'src/security/finance.guard';
import { HawafezGuard } from 'src/security/hawafez.guard';
import { RevenueReportComponent } from './Admin/revenue-report/revenue-report.component';
import { ElectronicArrestOrderComponent } from './Admin/electronic-arrest-order/electronic-arrest-order.component';
import { environment } from 'src/environments/environment';
import { RejectApplicationsComponent } from './ofdc/reject-applications/reject-applications.component';
import { OfdcRejectAppGuard } from 'src/security/ofdc-reject-app.guard';
import { EngineerTrainingComponent } from './investement/engineer-training/engineer-training.component';
import { MpwhManageEngGuard } from 'src/security/mpwh-manage-eng.guard';
import { AddExemptionBookComponent } from './Admin/add-exemption-book/add-exemption-book.component';
import { ActivityLicenseManageComponent } from './investement/activity-license-manage/activity-license-manage.component';
import { CompanyManageComponent } from './investement/company-manage/company-manage.component';
import { AddExemptionBookGuard } from 'src/security/add-exemption-book.guard';
import { CompanyAndLicenseGuard } from 'src/security/company-and-license.guard';
import { LoginInvestmentComponent } from './investement/login-Investment/login-investment.component';
import { CommitteesComponent } from './hcd/committees/committees.component';
import { DisabilityComponent } from './hcd/disability/disability.component';
import { ExamDatesComponent } from './hcd/exam-dates/exam-dates.component';
import {OtpComponent} from './otp/otp.component';

const mainPath = environment.MainPath; // قراءة القيمة من environment

const routes: Routes = [

  {path: mainPath+'/Otp', component: OtpComponent},
  {path: mainPath+'/LoginPage', component: LoginInvestmentComponent},
  {path: mainPath+'/SignUp',component:InvestementSignupComponent},
  {path: mainPath+'/ForgetPassword',component:InvestmentForgetPasswordComponent},
   {
    path:mainPath,
    component:AdminLayoutComponent,
    children:[
      {path:'committees',component:CommitteesComponent,},
    ]
  },

   {
    path:mainPath,
    component:AdminLayoutComponent,
    children:[
      {path:'disability',component:DisabilityComponent,},
    ]
  },

   {
    path:mainPath,
    component:AdminLayoutComponent,
    children:[
      {path:'exam_dates',component:ExamDatesComponent,},
    ]
  },

  { 
    path:'',
    component:DashboardComponent,
    children:[
      {path:'Entites',component:EntitiesComponent},
      { path: '', redirectTo: '/'+mainPath+'/Dashboard', pathMatch: 'full' }, // Default route (for the base URL)
    ],
  },
  {
    path:'',
    component:ServciesLayoutComponent,
    children:[
      {path:'test',component:TestComponent},
      {path:'Sections',component:SectionsComponent},
      {path:'Services',component:ServicesComponent},
      {path:'Form',component:FormComponent},
      {path:'MyRequests',component:MyRequestsComponent},
    ]
    ,canActivate:[ConsumerGuard],
  },
  {
    path:mainPath,
    component:ServciesLayoutComponent,
    children:[
      {path:'Dashboard',component:InvestmentDashboardComponent},
      {path:'Engineer',component:EngineerTrainingComponent,canActivate:[MpwhManageEngGuard] }, //,canActivate:[MpwhManageEngGuard] 
      {path:'Profile',component:InvestmentProfileComponent},
      {path:'ServiceOutput',component:ServiceOutputComponent},
    ]
    ,canActivate:[ConsumerGuard],
  },
  {
    path:mainPath,
    component:ServciesLayoutComponent,
    children:[
      {path:'Jamarek',component:JamarekComponent},
      {path:'EditJamarek',component:EdtiJamarekComponent},
      //{path:'JamarekTransferQuantity',component:JamarekTransferQuantityComponent},
      {path:'EditJamarekTransferQuantity',component:JamarekTransferQuantityComponent},
    ],
  },
  {
    path:mainPath,
    component:ServciesLayoutComponent,
    children:[
      {path:'CompanyInfo',component:CompanyInfoComponent},
    ],
    canActivate:[AuthGuard]
  },
  {
    path:mainPath+'/ControlPanel',
    component:AdminLayoutComponent,
    children:[
      {path:'FilterRequest',component:FilterRequestsComponent,canActivate:[AdminGuard]},
      {path:'manage-activity-license',component:ActivityLicenseManageComponent,canActivate:[CompanyAndLicenseGuard]},
      {path:'manage-company',component:CompanyManageComponent,canActivate:[CompanyAndLicenseGuard]},
      {path:'revenue-report',component:RevenueReportComponent,canActivate:[AdminGuard]},
      {path:'electronic-arrest-order',component:ElectronicArrestOrderComponent,canActivate:[AdminGuard]},
      {path:'Recipt',component:ReciptComponent,canActivate:[FinanceGuard]},
      {path:'Users',component:InvestmentUsersComponent,canActivate:[AdminGuard]},
      {path:'UserView',component:InvestmentUserViewComponent,canActivate:[AdminGuard]},
      {path:'Companies',component:CompaniesComponent,canActivate:[AdminGuard]},
      {path:'Exemptions',component:ExemptionsComponent,canActivate:[HawafezGuard]},
      {path:'add-exemption-book',component:AddExemptionBookComponent,canActivate:[AddExemptionBookGuard]},
    ]
  },
  {
    path:'ControlPanel',
    component:AdminLayoutComponent,
    children:[
      {path:'Reject',component:RejectApplicationsComponent,canActivate:[OfdcRejectAppGuard]},
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
   
}
